import { AppTreeSide, UniDateRangePicker } from 'components'
import ShowAlarmEvent from '../../common/showAlarmEvent'
import HandleAlarmEventModal from '../../common/handleAlarmEventModal'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {getTodayBeginAndEndDate, getOneWeekBeginAndEndDate} from '@/utils/date'

export default {
  name: 'alarmCenter',
  data () {
    return {
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 实时事件页面--------------------------------------------------------------------------------------------------
      realEventTableData: [],
      realEventTableTotalRow: 0,
      // 表格查询条件
      realEventDates: [], // 查询起始和结束日期
      realEventTableQueryParams: {
        lastEventId: 0,
        regionId: 0,
        descendantRegionRequired: 1,
        objectId: 0,
        resourceKind: 255,
        resourceSubType: 255,
        systemKind: 0, // 系统种类
        alarmStates: [],
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      realEventTableSelection: [],
      realEventTableSelectedIds: [],
      // 事件表格当前行
      realEventTableCurrentRow: null,
      // 事件信息弹窗
      showRealEventModalOpen: false,
      // 处理告警事件弹窗
      handleRealAlarmEventModalOpen: false,
      // 历史事件页面--------------------------------------------------------------------------------------------------
      // 表格数据
      historyEventTableData: [],
      historyEventTableTotalRow: 0,
      // 表格查询条件
      historyEventDates: [], // 查询起始和结束日期
      historyEventTableQueryParams: {
        lastEventId: 0,
        regionId: 0,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        systemKind: 0, // 系统种类
        alarmStates: [],
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      historyEventTableSelectedIds: [],
      // 事件表格当前行
      historyEventTableCurrentRow: null,
      // 事件信息弹窗
      showHistoryEventModalOpen: false,
      // 处理告警事件弹窗
      handleHistoryAlarmEventModalOpen: false,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker,
    ShowAlarmEvent,
    HandleAlarmEventModal
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  mounted () {
    // 设置查询起始日期和截止日期
    this.realEventDates = getTodayBeginAndEndDate() // 今天
    this.historyEventDates = getOneWeekBeginAndEndDate() // 近一周

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        // 开始数据轮巡
        this.startDataPolling()
      })
    })
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()
  },
  methods: {
    // 查询实时事件列表
    getRealEventList() {
      if (this.realEventTableQueryParams.lastEventId > 0 &&
        this.realEventTableQueryParams.lastEventId >= this.$store.getters.appLastEventId) { // 检测是否有新事件
        return
      }
      this.realEventTableQueryParams.lastEventId = this.$store.getters.appLastEventId // 更新最后事件id

      this.loading = true
      // 根据查询条件过滤实时事件数组
      let events = this.filterRealEvents()
      // 根据页面序号和大小返回实时事件数组起始和结束索引
      let beginIndex = (this.realEventTableQueryParams.pageNum - 1) * this.realEventTableQueryParams.pageSize
      let endIndex = this.realEventTableQueryParams.pageNum * this.realEventTableQueryParams.pageSize - 1
      if (endIndex > events.length - 1) {
        endIndex = events.length - 1
      }
      this.realEventTableData = []
      for (let i = beginIndex; i <= endIndex; ++i) {
        this.realEventTableData.push(events[i])
      }
      this.realEventTableTotalRow = events.length
      this.loading = false
    },
    // 过滤实时事件数组
    filterRealEvents() {
      let filteredEvents = []
      let event = null
      if ((this.realEventTableQueryParams.alarmStates.length === 0 || this.realEventTableQueryParams.alarmStates.length === 3) &&
        (this.realEventTableQueryParams.handleStates.length === 0 || this.realEventTableQueryParams.handleStates.length === 2)) { // 全部
        for (let i = 0; i < this.$store.getters.appNewEvents.length; ++i) {
          filteredEvents.unshift(this.$store.getters.appNewEvents[i]) // 倒序插入
        }
      } else {
        for (let i = 0; i < this.$store.getters.appNewEvents.length; ++i) {
          event = this.$store.getters.appNewEvents[i]
          if (this.realEventTableQueryParams.alarmStates.length === 0 || this.realEventTableQueryParams.alarmStates.length === 3 ||
            this.realEventTableQueryParams.alarmStates.includes(event.alarmState)) {
            if (this.realEventTableQueryParams.handleStates.length === 0 || this.realEventTableQueryParams.handleStates.length === 2 ||
              this.realEventTableQueryParams.handleStates.includes(event.handled)) {
              filteredEvents.unshift(event) // 倒序插入
            }
          }
        }
      }
      return filteredEvents
    },
    // 查询历史事件列表
    getHistoryEventList() {
      this.loading = true
      this.historyEventTableQueryParams.beginHappenDateTime = this.historyEventDates[0].getTime() / 1000
      this.historyEventTableQueryParams.endHappenDateTime = this.historyEventDates[1].getTime() / 1000
      this.$http(this.$api.historyEventList, this.historyEventTableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.historyEventTableData = res.data
            this.historyEventTableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 开始数据轮巡
    startDataPolling() {
      // 先执行一次
      if (this.activeTabName === '0') {
        this.getRealEventList()
      } else if (this.activeTabName === '1') {
      }

      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        if (this.activeTabName === '0') {
          this.getRealEventList()
        } else if (this.activeTabName === '1') {
        }
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      if (tab.name === '0') {

      } else if (tab.name === '1') {
        if (this.historyEventTableTotalRow === 0) {
          this.getHistoryEventList()
        }
      }
    },
    // 实时事件页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleRealEventFormQuery() {
      this.realEventTableQueryParams.page = 1
      this.realEventTableQueryParams.lastEventId = 0 // 最后获取事件id清零，否则如无新记录则不执行查询
      this.getRealEventList()
    },
    // 重置按钮操作
    resetRealEventQueryForm() {
      this.realEventTableQueryParams.regionId = 0
      this.realEventTableQueryParams.nodeId = 0
      this.realEventTableQueryParams.descendantRegionRequired = 1
      this.realEventTableQueryParams.resourceKind = 255
      this.realEventTableQueryParams.gaugedObjectKind = 255
      this.realEventTableQueryParams.systemKind = 0
      this.realEventTableQueryParams.alarmStates = []
      this.realEventDates = getTodayBeginAndEndDate() // 今天
      this.realEventTableQueryParams.beginHappenDateTime = 0
      this.realEventTableQueryParams.endHappenDateTime = 0
      this.realEventTableQueryParams.handleStates = []
      this.realEventTableQueryParams.pageNum = 1
      this.$refs['realEventQueryForm'].resetFields()
      this.handleRealEventFormQuery()
    },
    // 分页
    handleRealEventCurrentPageChange(val) {
      this.realEventTableQueryParams.pageNum = val
      this.realEventTableQueryParams.lastEventId = 0 // 最后获取事件id清零，否则如无新记录则不执行查询
      this.getRealEventList()
    },
    // 页面条数改变
    handleRealEventPageSizeChange(val) {
      this.realEventTableQueryParams.pageSize = val
      this.realEventTableQueryParams.lastEventId = 0 // 最后获取事件id清零，否则如无新记录则不执行查询
      this.getRealEventList()
    },
    // 表格选中记录改变
    handleRealEventTableSelectionChange(selection) {
      this.realEventTableSelection = selection
      this.realEventTableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleRealEventTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.realEventTableCurrentRow = currentRow
    },
    // 查看事件
    handleRealEventView(row) {
      if (row && row.id) {
        this.$refs.realEventTable.setCurrentRow(row) // 选中当前行
        this.showRealEventModalOpen = true
      }
    },
    // 处理事件
    handleRealEventHandle(row) {
      if (row && row.id) {
        this.$refs.realEventTable.setCurrentRow(row) // 选中当前行
        this.handleRealAlarmEventModalOpen = true
      } else if (this.realEventTableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定批量确认选中的' + this.realEventTableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.confirmAlarm, {
            eventIds: this.realEventTableSelectedIds,
            handleIdea: ''
          }).then(res => {
            if (res.code === 200) {
              this.realEventTableSelection.forEach(item => { // 实时事件直接修改确认状态
                item.handled = 1
              })
              this.$message({
                type: 'success',
                message: '提交成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '提交失败!'
              })
            }
          })
        })
      }
    },
    // 处理显示告警事件弹窗提交
    handleShowRealEventModalSubmit() {
      this.showRealEventModalOpen = false
      this.realEventTableCurrentRow.handled = 1
    },
    // 处理显示告警事件取消提交
    handleShowRealEventModalCancel() {
      this.showRealEventModalOpen = false
    },
    // 处理告警事件弹窗提交
    handleHandleRealAlarmEventModalSubmit() {
      this.handleRealAlarmEventModalOpen = false
      this.realEventTableCurrentRow.handled = 1
    },
    // 处理告警事件弹窗取消提交
    handleHandleRealAlarmEventModalCancel() {
      this.handleRealAlarmEventModalOpen = false
    },
    // 历史事件页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleHistoryEventFormQuery() {
      this.historyEventTableQueryParams.page = 1
      this.getHistoryEventList()
    },
    // 重置按钮操作
    resetHistoryEventQueryForm() {
      this.historyEventTableQueryParams.regionId = 0
      this.historyEventTableQueryParams.objectId = 0
      this.historyEventTableQueryParams.descendantRegionRequired = 1
      this.historyEventTableQueryParams.resourceKind = 255
      this.historyEventTableQueryParams.resourceSubType = 255
      this.realEventTableQueryParams.systemKind = 0
      this.historyEventTableQueryParams.alarmStates = []
      this.historyEventDates = getOneWeekBeginAndEndDate() // 近一周
      this.historyEventTableQueryParams.beginHappenDateTime = 0
      this.historyEventTableQueryParams.endHappenDateTime = 0
      this.historyEventTableQueryParams.handleStates = []
      this.historyEventTableQueryParams.pageNum = 1
      this.$refs['historyEventQueryForm'].resetFields()
      this.handleHistoryEventFormQuery()
    },
    // 分页
    handleHistoryEventCurrentPageChange(val) {
      this.historyEventTableQueryParams.pageNum = val
      this.getHistoryEventList()
    },
    // 页面条数改变
    handleHistoryEventPageSizeChange(val) {
      this.historyEventTableQueryParams.pageSize = val
      this.getHistoryEventList()
    },
    // 表格选中记录改变
    handleHistoryEventTableSelectionChange(selection) {
      this.historyEventTableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleHistoryEventTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.historyEventTableCurrentRow = currentRow
    },
    // 查看事件
    handleHistoryEventView(row) {
      if (row && row.id) {
        this.$refs.historyEventTable.setCurrentRow(row) // 选中当前行
        this.showHistoryEventModalOpen = true
      }
    },
    // 处理事件
    handleHistoryEventHandle(row) {
      if (row && row.id) {
        this.$refs.historyEventTable.setCurrentRow(row) // 选中当前行
        this.handleHistoryAlarmEventModalOpen = true
      } else if (this.historyEventTableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定批量确认选中的' + this.historyEventTableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.confirmAlarm, {
            eventIds: this.historyEventTableSelectedIds,
            handleIdea: ''
          }).then(res => {
            if (res.code === 200) {
              this.getHistoryEventList()
              this.$message({
                type: 'success',
                message: '提交成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '提交失败!'
              })
            }
          })
        })
      }
    },
    // 处理显示告警事件弹窗提交
    handleShowHistoryEventModalSubmit() {
      this.showHistoryEventModalOpen = false
      this.historyEventTableCurrentRow.handled = 1
    },
    // 显示告警事件信息取消提交
    handleShowHistoryEventModalCancel() {
      this.showHistoryEventModalOpen = false
    },
    // 处理告警事件弹窗提交
    handleHandleHistoryAlarmEventModalSubmit() {
      this.handleHistoryAlarmEventModalOpen = false
      this.historyEventTableCurrentRow.handled = 1
    },
    // 处理告警事件弹窗取消提交
    handleHandleHistoryAlarmEventModalCancel() {
      this.handleHistoryAlarmEventModalOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/alarmCenter/AlarmCenter.js